import React, { useEffect, useState } from "react";

import { useNavigate, useParams } from "react-router-dom";

import { Row, Col, Container, Button } from "react-bootstrap";

import { useDispatch } from "react-redux";

import { Content, Footer, Img, OrderNumber, SubLabel, Label } from "./styles";
import { getCart } from "../../Redux/cartSlice";
import { useUserData } from "../../hooks/UserContext";
import { useScreenTracking } from "../../hooks/useScreenTracking";
import { trackOrderStatusEvent } from "../../utils/gtm";
import { useApp } from "../../contexts/AppContext";
import LogoShop from "../../assets/aprovado.png";

export default function OrderResumeStatus() {
  const [Loading, setLoading] = useState(true);
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const screenName = useScreenTracking();

  const { user, addressShipping } = useUserData();
  const { whitelabel } = useApp();

  const channelDisplayName =
    (whitelabel?.assets?.name && String(whitelabel.assets.name).trim()) ||
    (whitelabel?.name && String(whitelabel.name).trim());

  const secondaryLabel = channelDisplayName
    ? `VOLTAR PARA ${channelDisplayName.toUpperCase()}`
    : "VOLTAR PARA A HOME";

  useEffect(() => {
    if (!id) return;

    const fetchData = async () => {
      setLoading(true);
      try {
        const uuid = user?.uuid;
        const cep = addressShipping?.cep ?? user?.addresses?.[0]?.cep;
        if (uuid && cep) {
          await dispatch(getCart({ uuid, cep, force: true })).unwrap();
        }
      } catch (err) {
        /*  notify('Erro ao tentar carregar campos', 'error')  */
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id, dispatch, user?.uuid, addressShipping?.cep, user?.addresses?.[0]?.cep]);

  return (
    !Loading && (
      <div className="wl-page">
        <Container>
          <Content>
            <Row className="justify-content-center mb-3">
              <Img src={LogoShop} alt="Order" />
              <Label>Pedido realizado!</Label>
            </Row>
            <Row>
              <SubLabel className="color-text-dark text-mg font-wl-400">
                Você receberá todas as informações do seu pedido em seu e-mail
                cadastrado.
              </SubLabel>
            </Row>
            <Row className="justify-content-center text-center bg-gray rounded">
              <Col>
                <p className="color-wl font-wl-400 text-mg m-0">
                  Nº do pedido
                </p>
                <h3 className="color-text-dark font-wl-600">{id}</h3>
              </Col>
            </Row>
            {/* <OrderNumber>
                      <Row>Nº do pedido</Row>
                      <Row>{id}</Row>
                  </OrderNumber> */}
          </Content>
        </Container>
        <Footer>
          <Button
            type="button"
            className="btn-default-wl"
            onClick={() => {
              trackOrderStatusEvent({
                title: "ir-para-meus-pedidos",
                contentType: "checkout",
                screenName,
              });
              navigate("/loja/myrequests/");
            }}
          >
            IR PARA MEUS PEDIDOS
          </Button>
          <Button
            type="button"
            className="btn-secondary-wl"
            onClick={async () => {
              trackOrderStatusEvent({
                title: "voltar-para-canal",
                contentType: "checkout",
                screenName,
              });
              const uuid = user?.uuid;
              const cep = addressShipping?.cep ?? user?.addresses?.[0]?.cep;
              if (uuid && cep) {
                try {
                  await dispatch(getCart({ uuid, cep, force: true })).unwrap();
                } catch {
                  /* mantém fluxo de navegação mesmo se o carrinho falhar */
                }
              }
              navigate("/loja", { replace: true });
            }}
          >
            {secondaryLabel}
          </Button>
        </Footer>
      </div>
    )
  );
}
